import './index.scss'
import _ from 'lodash'
import '../../assets/styles/swiper.min.css'
import '../../assets/scripts/swiper.min'

//banner轮播
window.onload = function () {
	bannerSwiper()
}
  function bannerSwiper() {
	let $bannerPaginationEl = $('.index-banner-pagination .list');
	let swiper = new Swiper('.banner-swiper', {
	  spaceBetween: 30,
	  effect: 'fade',
	  autoplay: {
		delay: 6000,
		disableOnInteraction: false,
	  },
		autoHeight: true,
	  pagination: {
		el: $bannerPaginationEl,
		clickable: true,
		bulletClass: 'asdasdasdasd',
		bulletActiveClass: 'active',
		modifierClass: 'askdjwkdjdk',
		renderBullet: function (index, className) {
		  return `
					<div class="item ${ className }" style="animation-duration: ${ this.passedParams.autoplay.delay }ms">
					<div class="dian"></div>
					</div>
				`;
		}
	  },
	  on: {
		slideChange: function () {
		  let ind = this.activeIndex+1
		  $('.swiper-numpagun .indexswiper').html('0'+ind)
		},
		init: function () {
		  let indall = this.slides.length
		  $('.swiper-numpagun .indexnumall').html('0'+indall)
		}
	  }
	})
  }  